import * as React from 'react';
import { Routes, Route, Navigate } from '@leagueplatform/routing';

import { AboutMeLandingPage } from '#pages/about-me-landing-page/index.ts';
import {
  DashboardRoutes,
  useIsDashboardEnabled,
} from '@leagueplatform/dashboard';
import { HealthReportPage } from '#pages/health-report-page/health-report-page.tsx';

export const AboutMeRoutes = () => {
  const { isDashboardEnabled } = useIsDashboardEnabled();
  return (
    <Routes>
      {/* The Apps and Devices screen doesn't exist on the web,
        we instead stay on the about me page and show the Apps and Devices modal. */}

      <Route
        path="apps-and-devices/*"
        element={
          <Navigate
            // pathname = ".." means to go to the relative parent route of the current location of this route in the route hierarchy.
            to={{ pathname: '..' }}
            state={{ showAppsAndDevicesModal: true }}
            replace
          />
        }
      />
      <Route index element={<AboutMeLandingPage />} />
      {isDashboardEnabled ? (
        <Route path="insights/*" element={<DashboardRoutes />} />
      ) : null}
      <Route path="hra-report/*" element={<HealthReportPage />} />
    </Routes>
  );
};
